import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const visitorId = () => {
  let v = localStorage.getItem("wlvp_vid");
  if (!v) {
    v = Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("wlvp_vid", v);
  }
  return v;
};

// First-party pageview beacon for the owner dashboard. No cookies, no IP stored.
export const PageTracker = () => {
  const { pathname, search } = useLocation();
  const first = useRef(true);
  useEffect(() => {
    const base = process.env.REACT_APP_BACKEND_URL;
    if (!base || pathname.startsWith("/admin")) return undefined;
    const body = JSON.stringify({
      path: pathname,
      ref: first.current ? document.referrer : "",
      w: window.innerWidth,
      vid: visitorId(),
      utm: new URLSearchParams(search).get("utm_source") || undefined,
    });
    first.current = false;
    fetch(`${base}/api/track`, { method: "POST", body, keepalive: true, headers: { "Content-Type": "text/plain" } }).catch(() => {});
    return undefined;
  }, [pathname, search]);
  return null;
};
